import 'C:\\Projects\\genkei\\zumeco\\static\\doodle\\view\\CanvasContainer.tsx.esbuild-plugin-linaria.css';
import 'C:\\Projects\\genkei\\zumeco\\static\\doodle\\view\\CanvasContainer.tsx.esbuild-plugin-windicss.css';
import { css, cx } from '@linaria/core';
import type { GestureFrame } from 'gesture-frame';
import 'gesture-frame/gesture-frame.css';
import 'gesture-frame/gesture-frame.js';
import type { JSX } from 'preact';
import { createSharedSelector, createSharedState } from 'preact-shared-state-hook';
import { memo } from 'preact/compat';
import { useEffect, useRef } from 'preact/hooks';
import { isMobileSafari } from '../../shared/utils';

// ↓ この指摘は eslint の間違い（バグ？）
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
const getCanvasContainer = () => document.querySelector('gesture-frame') as GestureFrame | null;
const [useScale, _setScale] = createSharedState(1);
const [useOffset, onChangeOffset] = createSharedState<readonly [number, number]>([0, 0]);
export { useOffset, useScale };
export const getScale = useScale.snapshot;
export const setScale = (scale: number) => {
  const container = getCanvasContainer();
  container && (container.scale = scale);
};
const horizontalMargin = 54 + 64;
const verticalMargin = 64;
export const adjustToSize = () => {
  const container = getCanvasContainer();
  if (!container) {
    return;
  }
  const content = container.shadowRoot!.querySelector<HTMLElement>('[part=content]')!;
  const widthBasedScale = (container.offsetWidth - horizontalMargin) / content.offsetWidth;
  const heightBasedScale = (container.offsetHeight - verticalMargin) / content.offsetHeight;
  if (widthBasedScale < heightBasedScale) {
    _setScale(container.scale = widthBasedScale);
    container.setOffset(54, 0);
  } else {
    _setScale(container.scale = heightBasedScale);
    container.setOffset(54 + (container.offsetWidth - horizontalMargin - heightBasedScale * content.offsetWidth) / 2, 0);
  }
};
export const adjustToWidth = () => {
  const container = getCanvasContainer();
  if (!container) {
    return;
  }
  const content = container.shadowRoot!.querySelector<HTMLElement>('[part=content]')!;
  container.scale = (container.offsetWidth - horizontalMargin) / content.offsetWidth;
  container.setOffset(54, 0);
};
export const CanvasContainer = memo(({
  className,
  pan,
  children
}: {
  className?: string;
  pan: boolean;
  children: JSX.Element;
}) => {
  const ref = useRef<GestureFrame>(null);
  useEffect(() => {
    const gestureFrame = ref.current!;
    const scaleObserver = new MutationObserver(() => _setScale(gestureFrame.scale));
    scaleObserver.observe(gestureFrame, {
      attributes: true,
      attributeFilter: ['scale']
    });
    const offsetObserver = new MutationObserver(() => onChangeOffset([gestureFrame.offsetX, gestureFrame.offsetY]));
    offsetObserver.observe(gestureFrame, {
      attributes: true,
      attributeFilter: ['offset-x', 'offset-y']
    });
    _setScale(gestureFrame.scale);
    onChangeOffset([gestureFrame.offsetX, gestureFrame.offsetY]);
    return () => {
      scaleObserver.disconnect();
      offsetObserver.disconnect();
    };
  }, []);
  return <gesture-frame ref={ref} pan-x={pan} pan-y={pan} min-scale={0.001} pinch-zoom class={cx("g38qlmc", className)}>
      {children}
    </gesture-frame>;
});

// [Mobile Safari] 仮想キーボード表示中、入力対象の入力ボックスが仮想キーボードで隠れないよう位置を調整します。
const [useMobileSafariVirtualKeyboardShown, setMobileSafariVirtualKeyboardShown] = createSharedState(false);
if (isMobileSafari && visualViewport) {
  const updateMobileSafariVirtualKeyboardShown = () => setMobileSafariVirtualKeyboardShown(innerHeight > visualViewport!.height + 100);
  visualViewport.addEventListener('resize', () => {
    updateMobileSafariVirtualKeyboardShown();
    setTimeout(updateMobileSafariVirtualKeyboardShown, 50);
    setTimeout(updateMobileSafariVirtualKeyboardShown, 100);
    setTimeout(updateMobileSafariVirtualKeyboardShown, 200);
  });
}
export { useMobileSafariVirtualKeyboardShown };
export const useInputAreaMaxY = isMobileSafari && visualViewport ? createSharedSelector([useMobileSafariVirtualKeyboardShown, useScale, useOffset], (isVirtualKeyboardShown, scale, offset) => isVirtualKeyboardShown ? (Math.max(40, visualViewport!.height - 240) - offset[1]) / scale : Infinity) : () => Infinity;